export default __webpack_public_path__ + "static/media/640_business05-nl-mobile.e844237f.png";